<template>
  <div class="leftMenu" v-show="isShow">
    <div
      class="menuItem"
      :class="{ menuChecked: activeIndex === index }"
      v-for="(item, index) in dataSource.floors"
      @click="onCheck(index)"
    >
      {{ item.floorName }}
    </div>
  </div>
</template>

<script>
import {
  spliceString,
  elementIsVisibleInViewport,
  scrollIntoView,
} from "@/utils";

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeIndex: "",
      scrollTop: 0,
      bannerHeight: 0,
    };
  },
  computed: {
    isShow() {
      return this.bannerHeight && this.scrollTop >= this.bannerHeight;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.getVisible);
  },
  destroyed() {
    window.removeEventListener("scroll", this.getVisible);
  },
  methods: {
    onCheck(index) {
      // this.activeIndex = index;
      const id = "floor_" + index;
      const dom = document.getElementById(id);

      const offset = window.screen.height - 300;
      scrollIntoView(dom, -offset, true);
    },
    getBannerHeight() {
      const dom = document.getElementById("specialActivity-banner");
      if (dom) {
        const rect = dom.getBoundingClientRect();
        if (rect.height > this.bannerHeight) {
          this.bannerHeight = rect.height;
        }
      }
    },
    // 获取哪些模块在视图里
    getVisible() {
      this.getBannerHeight();
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      const visibleIndex = this.visibleIndex();
      if (visibleIndex.length >= 1) {
        this.$nextTick(() => {
          this.activeIndex = visibleIndex[0];
        });
      }
    },
    // 返回视图内的相应序号
    visibleIndex() {
      let jumpArr = [];
      let allSides = [];

      const homeDynamicsDom = document.getElementById(
        "specialActivity-dynamics"
      );

      if (homeDynamicsDom) {
        [...homeDynamicsDom.children].forEach((item) => {
          const targetDom = item;
          if (targetDom) {
            allSides.push(targetDom);
          }
        });
      }
      allSides.forEach((item, index) => {
        elementIsVisibleInViewport(item, true, 0, 240) && jumpArr.push(index);
      });
      return jumpArr;
    },
  },
};
</script>

<style lang="scss" scoped>
.leftMenu {
  width: 120px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 16px;
  background: #f5f6fa;

  position: fixed;
  top: 100px;
  left: 1%;
  .menuItem {
    width: 115px;
    border-radius: 14px;
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    color: #666666;
    text-align: center;
    padding: 8px;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .menuChecked {
    color: #2a54d1;
    font-weight: bold;
    background: #ffffff;
  }
}
</style>
